var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import VueI18n from "vue-i18n";
import { localize } from "vee-validate";
/**
 *
 * Loads localization files and initialize i18n
 *
 **/
export function initializeI18n(resourceService, lang) {
    return __awaiter(this, void 0, Promise, function () {
        var generalMessages, i18n, _a, reportResources, aidTargetYearlyReportResources, aidapplicationResources, validationResources, newApplicationResources, organisationResources, enumResources, budgetaryEstimateResources, correspondenceResouces, feedbackResources, accountNumberResources, expandedResources, paymentPlanResources, paymentRequestERResources, summaryReportResources, continuousReportResources, continuousReportSummaryResources, paymentResources, aupResources, investmentReportResources, materialRequestResources, notificationResources, changeRequestResources, userManagementResources, loginResources, legacyInformationRequestResources, htmlResources, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, resourceService.getResourcesAsync("general")];
                case 1:
                    generalMessages = _b.sent();
                    i18n = new VueI18n({
                        locale: lang == null ? "fi" : lang.toString(),
                        fallbackLocale: "fi",
                        messages: {
                            fi: generalMessages.fi,
                            sv: generalMessages.sv
                        }
                    });
                    return [4 /*yield*/, Promise.all([
                            resourceService.getResourcesAsync("organisationYearlyReport"),
                            resourceService.getResourcesAsync("aidTargetYearlyReport"),
                            resourceService.getResourcesAsync("aidApplication"),
                            resourceService.getResourcesAsync("validationMessages"),
                            resourceService.getResourcesAsync("newApplication"),
                            resourceService.getResourcesAsync("organisation"),
                            resourceService.getResourcesAsync("enums"),
                            resourceService.getResourcesAsync("budgetaryEstimate"),
                            resourceService.getResourcesAsync("correspondence"),
                            resourceService.getResourcesAsync("feedback"),
                            resourceService.getResourcesAsync("accountNumberRequest"),
                            resourceService.getResourcesAsync("expandedSBE"),
                            resourceService.getResourcesAsync("paymentPlan"),
                            resourceService.getResourcesAsync("paymentRequestER"),
                            resourceService.getResourcesAsync("summaryReport"),
                            resourceService.getResourcesAsync("continuousReport"),
                            resourceService.getResourcesAsync("continuousReportSummary"),
                            resourceService.getResourcesAsync("payments"),
                            resourceService.getResourcesAsync("aupReport"),
                            resourceService.getResourcesAsync("investmentReport"),
                            resourceService.getResourcesAsync("materialRequest"),
                            resourceService.getResourcesAsync("notification"),
                            resourceService.getResourcesAsync("changeRequest"),
                            resourceService.getResourcesAsync("userManagement"),
                            resourceService.getResourcesAsync("login"),
                            resourceService.getResourcesAsync("legacyInformationRequest"),
                            resourceService.getHtmlResourcesAsync()
                        ])];
                case 2:
                    _a = __read.apply(void 0, [_b.sent(), 27]), reportResources = _a[0], aidTargetYearlyReportResources = _a[1], aidapplicationResources = _a[2], validationResources = _a[3], newApplicationResources = _a[4], organisationResources = _a[5], enumResources = _a[6], budgetaryEstimateResources = _a[7], correspondenceResouces = _a[8], feedbackResources = _a[9], accountNumberResources = _a[10], expandedResources = _a[11], paymentPlanResources = _a[12], paymentRequestERResources = _a[13], summaryReportResources = _a[14], continuousReportResources = _a[15], continuousReportSummaryResources = _a[16], paymentResources = _a[17], aupResources = _a[18], investmentReportResources = _a[19], materialRequestResources = _a[20], notificationResources = _a[21], changeRequestResources = _a[22], userManagementResources = _a[23], loginResources = _a[24], legacyInformationRequestResources = _a[25], htmlResources = _a[26];
                    if (reportResources) {
                        i18n.mergeLocaleMessage("fi", reportResources.fi);
                        i18n.mergeLocaleMessage("sv", reportResources.sv);
                    }
                    if (aidTargetYearlyReportResources) {
                        i18n.mergeLocaleMessage("fi", aidTargetYearlyReportResources.fi);
                        i18n.mergeLocaleMessage("sv", aidTargetYearlyReportResources.sv);
                    }
                    if (aidapplicationResources) {
                        i18n.mergeLocaleMessage("fi", aidapplicationResources.fi);
                        i18n.mergeLocaleMessage("sv", aidapplicationResources.sv);
                    }
                    if (validationResources) {
                        i18n.mergeLocaleMessage("fi", validationResources.fi);
                        i18n.mergeLocaleMessage("sv", validationResources.sv);
                    }
                    if (newApplicationResources) {
                        i18n.mergeLocaleMessage("fi", newApplicationResources.fi);
                        i18n.mergeLocaleMessage("sv", newApplicationResources.sv);
                    }
                    if (organisationResources) {
                        i18n.mergeLocaleMessage("fi", organisationResources.fi);
                        i18n.mergeLocaleMessage("sv", organisationResources.sv);
                    }
                    if (enumResources) {
                        i18n.mergeLocaleMessage("fi", enumResources.fi);
                        i18n.mergeLocaleMessage("sv", enumResources.sv);
                    }
                    if (budgetaryEstimateResources) {
                        i18n.mergeLocaleMessage("fi", budgetaryEstimateResources.fi);
                        i18n.mergeLocaleMessage("sv", budgetaryEstimateResources.sv);
                    }
                    if (correspondenceResouces) {
                        i18n.mergeLocaleMessage("fi", correspondenceResouces.fi);
                        i18n.mergeLocaleMessage("sv", correspondenceResouces.sv);
                    }
                    if (feedbackResources) {
                        i18n.mergeLocaleMessage("fi", feedbackResources.fi);
                        i18n.mergeLocaleMessage("sv", feedbackResources.sv);
                    }
                    if (accountNumberResources) {
                        i18n.mergeLocaleMessage("fi", accountNumberResources.fi);
                        i18n.mergeLocaleMessage("sv", accountNumberResources.sv);
                    }
                    if (expandedResources) {
                        i18n.mergeLocaleMessage("fi", expandedResources.fi);
                        i18n.mergeLocaleMessage("sv", expandedResources.sv);
                    }
                    if (paymentPlanResources) {
                        i18n.mergeLocaleMessage("fi", paymentPlanResources.fi);
                        i18n.mergeLocaleMessage("sv", paymentPlanResources.sv);
                    }
                    if (paymentRequestERResources) {
                        i18n.mergeLocaleMessage("fi", paymentRequestERResources.fi);
                        i18n.mergeLocaleMessage("sv", paymentRequestERResources.sv);
                    }
                    if (summaryReportResources) {
                        i18n.mergeLocaleMessage("fi", summaryReportResources.fi);
                        i18n.mergeLocaleMessage("sv", summaryReportResources.sv);
                    }
                    if (continuousReportResources) {
                        i18n.mergeLocaleMessage("fi", continuousReportResources.fi);
                        i18n.mergeLocaleMessage("sv", continuousReportResources.sv);
                    }
                    if (continuousReportSummaryResources) {
                        i18n.mergeLocaleMessage("fi", continuousReportSummaryResources.fi);
                        i18n.mergeLocaleMessage("sv", continuousReportSummaryResources.sv);
                    }
                    if (paymentResources) {
                        i18n.mergeLocaleMessage("fi", paymentResources.fi);
                        i18n.mergeLocaleMessage("sv", paymentResources.sv);
                    }
                    if (aupResources) {
                        i18n.mergeLocaleMessage("fi", aupResources.fi);
                        i18n.mergeLocaleMessage("sv", aupResources.sv);
                    }
                    if (investmentReportResources) {
                        i18n.mergeLocaleMessage("fi", investmentReportResources.fi);
                        i18n.mergeLocaleMessage("sv", investmentReportResources.sv);
                    }
                    if (materialRequestResources) {
                        i18n.mergeLocaleMessage("fi", materialRequestResources.fi);
                        i18n.mergeLocaleMessage("sv", materialRequestResources.sv);
                    }
                    if (notificationResources) {
                        i18n.mergeLocaleMessage("fi", notificationResources.fi);
                        i18n.mergeLocaleMessage("sv", notificationResources.sv);
                    }
                    if (changeRequestResources) {
                        i18n.mergeLocaleMessage("fi", changeRequestResources.fi);
                        i18n.mergeLocaleMessage("sv", changeRequestResources.sv);
                    }
                    if (userManagementResources) {
                        i18n.mergeLocaleMessage("fi", userManagementResources.fi);
                        i18n.mergeLocaleMessage("sv", userManagementResources.sv);
                    }
                    if (loginResources) {
                        i18n.mergeLocaleMessage("fi", loginResources.fi);
                        i18n.mergeLocaleMessage("sv", loginResources.sv);
                    }
                    if (legacyInformationRequestResources) {
                        i18n.mergeLocaleMessage("fi", legacyInformationRequestResources.fi);
                        i18n.mergeLocaleMessage("sv", legacyInformationRequestResources.sv);
                    }
                    if (htmlResources) {
                        i18n.mergeLocaleMessage("fi", htmlResources.fi);
                        i18n.mergeLocaleMessage("sv", htmlResources.sv);
                    }
                    // Activate localization locale
                    localize(i18n.locale);
                    return [2 /*return*/, i18n];
                case 3:
                    e_1 = _b.sent();
                    throw new Error("Failed to initialize i18n. Error: " + e_1);
                case 4: return [2 /*return*/];
            }
        });
    });
}
